export const GET_USER_REQ="GET_USER_REQ"
export const GET_USER_SUCCESS="GET_USER_SUCCESS"
export const GET_USER_FAIL="GET_USER_FAIL"


export const ADD_USER="ADD_USER"
export const ADD_USER_SUCCESS="ADD_USER_SUCCESS"
export const ADD_USER_FAIL="ADD_USER_FAIL"



export const  REMOVE_USER_REQ="REMOVE_USER_REQ"
export const  REMOVE_USER_SUCCESS="REMOVE_USER_SUCCESS"
export const  REMOVE_USER_FAIL="REMOVE_USER_FAIL"


export const  UPDATE_USER_REQ="UPDATE_USER_REQ"
export const  UPDATE_USER_SUCCESS="UPDATE_USER_SUCCESS"
export const  UPDATE_USER_FAIL="UPDATE_USER_FAIL"


// -----card actions -----

export const ADD_CARD="ADD_CARD"

export const ADD_CARD_REQ="ADD_CARD_REQ"
export const ADD_CARD_SUCCESS="ADD_CARD__SUCCESS"
export const ADD_CARD_FAIL="ADD_CARD_FAIL"


export const GET_CARD_REQ="GET_CARD_REQ"
export const GET_CARD_SUCCESS="GET_CARD__SUCCESS"
export const GET_CARD_FAIL="GET_CARD_FAIL"


export const  REMOVE_CARD_REQ="REMOVE_CARD_REQ"
export const  REMOVE_CARD_SUCCESS="REMOVE_CARD_SUCCESS"
export const  REMOVE_CARD_FAIL="REMOVE_CARD_FAIL"


export const  UPDATE_CARD_REQ="UPDATE_CARD_REQ"
export const  UPDATE_CARD_SUCCESS=" UPDATE_CARD_SUCCESS"
export const  UPDATE_CARD_FAIL="UPDATE_CARD_FAIL"


